var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointmentCountCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F9EAA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5834 53.0423C21.5834 56.0882 23.9126 58.4173 26.9584 58.4173H52.0417C55.0876 58.4173 57.4167 56.0882 57.4167 53.0423V38.709H21.5834V53.0423ZM52.0417 26.1673H48.4584V24.3757C48.4584 23.3007 47.7417 22.584 46.6667 22.584C45.5917 22.584 44.8751 23.3007 44.8751 24.3757V26.1673H34.1251V24.3757C34.1251 23.3007 33.4084 22.584 32.3334 22.584C31.2584 22.584 30.5417 23.3007 30.5417 24.3757V26.1673H26.9584C23.9126 26.1673 21.5834 28.4965 21.5834 31.5423V35.1257H57.4167V31.5423C57.4167 28.4965 55.0876 26.1673 52.0417 26.1673Z",
    fill: "#34623F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentCountCardIcon);
export default __webpack_public_path__ + "static/media/appointment-count-card-icon.f384052d03b8a305b07a093641d59ba3.svg";
export { ForwardRef as ReactComponent };